import { createBrowserRouter, Navigate } from "react-router-dom";
import { Qpay, QpayBalance } from "pages";
import Layout from "layout";

// "/" is the static TSC landing (public/index.html). The registration modal +
// QPay payment live inside that landing (vanilla, see public/js/register-integration.js).
// React only serves the standalone /qpay/:guid payment links for returning applicants.
const Empty = () => null;

const router = createBrowserRouter([
  { path: "/", element: <Empty /> },
  {
    path: "/qpay",
    element: <Layout />,
    children: [
      { path: ":guid", element: <Qpay /> },
      { path: "balance/:guid", element: <QpayBalance /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);

export default router;
